import { TTrackEventData } from './../../../tracking/constant/index';
export const DELIVERY_DASHBOARD_TRACKING_EVENTS = {
  COMPONENT_NAME: 'delivery dashboard',
  ORDERS: {
    ASSIGNMENT: {
      event: 'order_assignment',
      component_name: 'order detail',
      component_type: 'order'
    },
    DETAIL: {
      event: 'order_detail',
      component_name: 'order detail',
      component_type: 'order'
    }
  },
  COURIERS: {},
  NAVIGATION: {
    TAB: {
      event: 'button_action',
      action: '', // dynamic value
      component_type: 'button',
    },
    VIEW_ONLOAD: {
      component_type: 'list',
      event: 'list_view',
      list_action: 'view',
    }
  },
};

export type TDeliveryDashboardButtonNavigationTab = TTrackEventData<{
  button_action: string;
}>;

export type TDeliveryDashboardNavigationView = TTrackEventData<{
  list_countsTotals: string;
  list_filter: string;
  list_action: string;
}>;

export type TDeliveryDashboardOrderAssignment = TTrackEventData<{
    order_action: string;
    order_id: string;
    order_hashed:string;
    order_alcohol: boolean;
    courier_vehicle?: string;
}>

export type TDeliveryDashboardOrderDetailClick = TTrackEventData<{
  order_action: string;
  order_alcohol: boolean;
  order_hashed: string;
  order_id: string;
}>
